// @flow
import React from "react";
import Toolbar from "@material-ui/core/Toolbar";
import { List, Map } from "immutable";
import SearchInput from "components/SearchInput";
import Paper from "@material-ui/core/Paper";
import Breadcrumbs from "./Breadcrumbs";

type Props = {
  breadcrumbs: List<Map<string, string>>,
  onSubmit: (string) => void,
  url: string,
  redirect: (string) => void,
};

const HelpToolbar = (props: Props) => {
  return (
    <Paper elevation={2}>
      <Toolbar>
        <Breadcrumbs
          color="primary"
          breadcrumbs={props.breadcrumbs}
          url={props.url}
          redirect={props.redirect}
        />
        <SearchInput
          placeholder="Search FAQ"
          onSubmit={(query) => props.onSubmit(query)}
        />
      </Toolbar>
    </Paper>
  );
};

export default HelpToolbar;
